import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { RiderProfileLayoutContextInterface } from "../RiderProfileLayout";
//import ImageInput from "../../../Components/ImageInput";
import { patrollerService } from "../../../Api/Services/PatrollerService";
import { riderService } from "../../../Api/Services/RiderService";
import { useLoading } from "../../../Context/LoadingProvider";
import { RiderProductModel } from "../../../Api/Models/rider.model";
import { KitModel } from "../../../Api/Models/product.model";
import { ReturnStatus } from "../../../Api/Models/return.model";
import { KitProductModel } from "../../../Api/Models/product.model";
import AssignNewGearItem from "../AssignNewGearItem";
import CheckBtn from "../../../Components/CheckBtn";
import { HangerIcon } from "../../../Components/Icons/HangerIcon";
import { AngleRightIcon } from "../../../Components/Icons/AngleRightIcon";
import { HornIcon } from "../../../Components/Icons/HornIcon";
import { CloseIcon } from "../../../Components/Icons/CloseIcon";
import RadioListItem from "../../../Components/RadioListItem";

const GearCheckStep: React.FunctionComponent<any> = ({setStep, setProgressStep}) => {


    const {t} = useTranslation();

    const gearConditionTypes: Record<string, string[] | null> = {
        Good: null,
        Damaged: null,
        Missing: ["Stolen", "Damaged", "Lost", "Forgot"],
        Unbranded: ["Forgot", "Given to washing"],
        "Old branding": ["New forgot", "New stolen", "New Damaged", "Given to washing"],
        Dirty: null,
    };

    const [gearConditionSelectorModal, setGearConditionSelectorModal] = useState<{
        gearConditionIdx?: string;
        gearKey?: string;
        imageUrl?: string;
        gearName?: string;
        itemStatus?: string;
        __view?: 'main' | 'sub';
        __selectedMain?: string | null;
    } | null>(null);

    const gearNotTalabatConditionTypes: Record<string, string[] | null> = {
        Good: null,
        Damaged: null,
        Missing: ["Stolen", "Damaged", "Lost", "Forgot"],
        Unbranded: ["Forgot", "Given to washing"],
        "Old branding": ["New forgot", "New stolen", "New Damaged", "Given to washing"],
        Dirty: null,
    };

    const [gearNotTalabatConditionSelectorModal, setGearNotTalabatConditionSelectorModal] = useState<{
        gearConditionIdx?: string;
        imageUrl?: string;
        gearName?: string;
        itemStatus?: string;
        __view?: 'main' | 'sub';
        __selectedMain?: string | null;
    } | null>(null);

    const {
        setSubTitle,
        rider,
    } = useOutletContext<RiderProfileLayoutContextInterface>();
    const { startLoading, finnishLoading } = useLoading();
    const [showAssignNewGearItem, setShowAssignNewGearItem] = useState(false);
    const [gearsCondition, setGearsCondition] = useState<Record<any, any>>({});
    const [gearsOverdueCommunicated, setGearsOverdueCommunicated] = useState<boolean | undefined>(false);
    const [gearsNotTalabatCondition, setGearsNotTalabatCondition] = useState<Record<any, any>>({});
    const [gearsNotTalabat, setGearsNotTalabat] = useState<any[]>([]);
    //const [gearsConfirmationImage, setGearsConfirmationImage] = useState<File[]>([]);
    const [gears, setGears] = useState<RiderProductModel[]>([]);
    const [missingKitProducts, setMissingKitProducts] = useState<KitModel | null>(null);
    //const [showErrorMessages, setShowErrorMessages] = useState<boolean>(false);
    const historicalGear = localStorage.getItem("historicalGear");
    const gearReport = localStorage.getItem("gearReport");
    const [riderHasNoUniform, setRiderHasNoUniform] = useState(false);
    const [showError, setShowError] = useState(false);
    const riderApperanceIsGood = useMemo(() => {
        const shitToSend = [];
        for (const key in gearsCondition) {
            if (gearsCondition[key]["itemStatus"] === 'Good') {
                continue;
            }
            shitToSend.push(gearsCondition[key]);
        }

        for (const key in gearsNotTalabatCondition) {
            if (gearsNotTalabatCondition[key]["itemStatus"] === 'Good') {
                continue;
            }
            shitToSend.push(gearsNotTalabatCondition[key]);
        }

        return shitToSend.length <= 0;
    }, [gearsCondition, gearsNotTalabatCondition]);

    useEffect(() => {
        if (gearReport === '0') {
            setStep((prev: number) => prev + 1);
            setProgressStep((prev: number) => prev + 1);
        }
    }, [gearReport, setStep, setProgressStep]);

    useEffect(() => {
        setSubTitle();
    }, [t, setSubTitle]);

    const fetchGears = () => {
        startLoading("get-profile-gear");
        riderService
            .listGear(rider.riderId)
            .then((gear) => {
                const filteredGears = gear.filter((product) => {
                    return product.shouldBeChecked;
                })

                const uniqueGears = filteredGears.filter((product, index) => {
                    return filteredGears.findIndex(t => t.productId === product.productId && t.productVariationId === product.productVariationId) === index;
                });

                setGears(uniqueGears);
            })
            .finally(() => {
                finnishLoading("get-profile-gear");
            });

        fetchNonTalabatGears();
    };

    const fetchNonTalabatGears = () => {
        startLoading("get-non-talabat-gear");
        patrollerService
            .getNonTalabatGears()
            .then((gears) => {
                setGearsNotTalabat(gears);
            })
            .finally(() => {
                finnishLoading("get-non-talabat-gear");
            });

        fetchMissingKitProducts();
    };

    const fetchMissingKitProducts = () => {
        startLoading("get-missing-produts");
        riderService
            .getMissingKitProducts(rider.riderId)
            .then((kit) => {
                setMissingKitProducts(kit);
            })
            .finally(() => {
                finnishLoading("get-missing-produts");
            });
    };

    useEffect(() => {
        for (let i = 0; i < gears.length; i++) {
            gearsCondition[i.toString()] = {};

            gearsCondition[i.toString()]["itemStatus"] = undefined;
            gearsCondition[i.toString()]["imageUrl"] = gears[i].productImage;
            gearsCondition[i.toString()]["gearName"] = gears[i].productName + " " + (gears[i].variationName ?? "");
            gearsCondition[i.toString()]["gearBaseName"] = gears[i].productName;
            gearsCondition[i.toString()]["gearVariationName"] = gears[i].variationName;
            gearsCondition[i.toString()]["gearId"] = gears[i].productId;
            gearsCondition[i.toString()]["variationId"] = gears[i].productVariationId;
            gearsCondition[i.toString()]["gearAssignedOn"] = gears[i].assignedAt;
            gearsCondition[i.toString()]["eligibleForExchange"] = gears[i].exchangeAvailableAt;


            setGearsCondition({...gearsCondition});
        }
        //eslint-disable-next-line
    }, [gears]);

    useEffect(() => {
        for (let i = 0; i < gearsNotTalabat.length; i++) {
            gearsNotTalabatCondition[i.toString()] = {};

            gearsNotTalabatCondition[i.toString()]["itemStatus"] = undefined;
            gearsNotTalabatCondition[i.toString()]["imageUrl"] = gearsNotTalabat[i].imageUrl;
            gearsNotTalabatCondition[i.toString()]["gearName"] = gearsNotTalabat[i].name;
            gearsNotTalabatCondition[i.toString()]["gearId"] = gearsNotTalabat[i].id;
            gearsNotTalabatCondition[i.toString()]["variationId"] = undefined;
            gearsNotTalabatCondition[i.toString()]["gearAssignedOn"] = undefined;
            gearsNotTalabatCondition[i.toString()]["eligibleForExchange"] = undefined;


            setGearsNotTalabatCondition({...gearsNotTalabatCondition});
        }
        //eslint-disable-next-line
    }, [gearsNotTalabat]);

    function setGearCondition(key: string, status: string) {
        setGearsCondition(prev => ({
            ...prev,
            [key]: { ...prev[key], itemStatus: status }
        }));
    }

    function setGearNotTalabatCondition(key: string, status: string) {
        setGearsNotTalabatCondition(prev => ({
            ...prev,
            [key]: { ...prev[key], itemStatus: status }
        }));
    }

    const setAllGearsToGoodOrBad = (toGood: boolean) => {
        setGearsCondition(prev => {
            const updated = Object.fromEntries(
                Object.entries(prev).map(([key, val]) => [
                    key,
                    { ...val, itemStatus: toGood ? 'Good' : undefined },
                ])
            );
            return updated;
        });

        setGearsNotTalabatCondition(prev => {
            const updated = Object.fromEntries(
                Object.entries(prev).map(([key, val]) => [
                    key,
                    { ...val, itemStatus: toGood ? 'Good' : undefined },
                ])
            );
            return updated;
        });
    };


    const handleNext = () => {
        const allSelected = Object.values(gearsCondition).every(
            (gear: any) => gear.itemStatus !== undefined && gear.itemStatus !== null
        );

        const allNotTalabatSelected = Object.values(gearsNotTalabatCondition).every(
            (gear: any) => gear.itemStatus !== undefined && gear.itemStatus !== null
        );

        const shouldCheckCommunication =
            (gears && gears.filter((product) => {
                return !(product.exchangeDays && product.returnStatus !== ReturnStatus.MISSING);
            }).length > 0) ||
            (missingKitProducts && missingKitProducts.products.length > 0);

        const communicationChecked = !shouldCheckCommunication || gearsOverdueCommunicated === true;

        if (!allSelected || !allNotTalabatSelected || !communicationChecked) {
            setShowError(true);
            return;
        }

        const shitToSend = [];
        for (const key in gearsCondition) {
            if (gearsCondition[key]["itemStatus"] === 'Good') {
                continue;
            }
            shitToSend.push(gearsCondition[key]);
        }

        for (const key in gearsNotTalabatCondition) {
            if (gearsNotTalabatCondition[key]["itemStatus"] === 'Good') {
                continue;
            }
            shitToSend.push(gearsNotTalabatCondition[key]);
        }

        const fullData = {
            meta: {
                riderApperanceIsGood: riderApperanceIsGood,
                gearsOverdueCommunicated: gearsOverdueCommunicated,
                riderHasNoUniform: riderHasNoUniform,
            },
            data: shitToSend,
            picture: null,
        };

        startLoading('vehicle-verification');
        patrollerService.saveGearCheckData(rider.riderId, fullData)
            ?.then(() => {
                setStep((prev: number) => prev + 1);
                setProgressStep((prev: number) => prev + 1);
            })
            .finally(() => {
                finnishLoading('vehicle-verification');
            });
    };

    /*interface ModalProps {
        message: string;
        onClose: () => void;
    }

    const Modal: React.FC<ModalProps> = ({ message, onClose }) => {
        return (
            <div className="modal-overlay">
                <div className="modal-content">
                    <p>{message}</p>
                    <button onClick={onClose} className="modal-close-button">
                        Close
                    </button>
                </div>
            </div>
        );
    };*/

    const handleNoUniformClick = () => {
        setRiderHasNoUniform(true);
        setShowError(false);
    };


    useEffect(() => {
        fetchGears();
        //eslint-disable-next-line
    }, []);

    return (
        <>
            {gearConditionSelectorModal && (
                <div className={"bottom-modal"} tabIndex={-1} aria-modal="true" role="dialog">
                    <div className="bottom-modal__scroll-content">
                        <div className="bottom-modal__body" style={{ marginTop: "50px" }}>

                            <div className="stock-item__image">
                                <img
                                    src={gearConditionSelectorModal.imageUrl ?? ""}
                                    style={{ height: "60px", width: "auto" }}
                                    alt="Product"
                                />
                            </div>

                            <div className="flex justify-end mb-4">
                                <div
                                    className="bottom-modal__close"
                                    onClick={() => setGearConditionSelectorModal(null)}
                                >
                                    <CloseIcon />
                                </div>
                            </div>

                            {gearConditionSelectorModal.__view !== 'sub' && (
                                <>
                                    <div className="stock-item__title heading text-center mb-2">
                                        {gearConditionSelectorModal.gearName ?? ""}
                                    </div>
                                    <div className="text-light text-center mb-4">
                                        {t("Select the correct condition!")}
                                    </div>

                                    {Object.entries(gearConditionTypes).map(([mainKey, subOptions]) => (
                                        <div key={mainKey} className="mb-2">
                                            <RadioListItem
                                                label={t(mainKey)}
                                                selected={Boolean(gearConditionSelectorModal.itemStatus?.startsWith(mainKey))}
                                                onSelect={() => {
                                                    if (!subOptions) {
                                                        setGearConditionSelectorModal(prev => ({
                                                            ...prev!,
                                                            itemStatus: mainKey,
                                                        }));
                                                    } else {
                                                        setGearConditionSelectorModal(prev => ({
                                                            ...prev!,
                                                            __view: 'sub',
                                                            __selectedMain: mainKey,
                                                            itemStatus:
                                                                prev?.itemStatus?.startsWith(mainKey)
                                                                    ? prev.itemStatus
                                                                    : `${mainKey} - ${subOptions[0]}`,
                                                        }));
                                                    }
                                                }}
                                            />
                                            <div className="separator-line" style={{ padding: 0 }} />
                                        </div>
                                    ))}

                                    <div className="flex gap-4 mt-4">
                                        <div className="flex-1">
                                            <button
                                                type="button"
                                                className="button button--light"
                                                onClick={() => setGearConditionSelectorModal(null)}
                                            >
                                                {t("Back")}
                                            </button>
                                        </div>
                                        <div className="flex-1">
                                            <button
                                                type="submit"
                                                className="button"
                                                onClick={() => {
                                                    const m = gearConditionSelectorModal;
                                                    if (!m) return;
                                                    const selectedMain = m.itemStatus?.split(" - ")[0];
                                                    if (selectedMain && Array.isArray(gearConditionTypes[selectedMain])) {
                                                        setGearConditionSelectorModal(prev => ({
                                                            ...prev!,
                                                            __view: 'sub',
                                                            __selectedMain: selectedMain,
                                                        }));
                                                        return;
                                                    }
                                                    if (!m.gearConditionIdx || !m.itemStatus) return;
                                                    setGearCondition(m.gearConditionIdx, m.itemStatus);
                                                    setGearConditionSelectorModal(null);
                                                }}
                                            >
                                                {t("Save")}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}

                            {gearConditionSelectorModal.__view === 'sub' && (
                                <>
                                    <div className="stock-item__title heading text-center mb-2">
                                        {t(gearConditionSelectorModal.__selectedMain || "")}
                                    </div>
                                    <div className="text-light text-center mb-4">
                                        {t("Select a specific reason")}
                                    </div>

                                    {(gearConditionTypes[gearConditionSelectorModal.__selectedMain || ""] || []).map(sub => {
                                        const full = `${gearConditionSelectorModal.__selectedMain} - ${sub}`;
                                        return (
                                            <div key={sub} className="mb-2">
                                                <RadioListItem
                                                    label={t(sub)}
                                                    selected={gearConditionSelectorModal.itemStatus === full}
                                                    onSelect={() => {
                                                        setGearConditionSelectorModal(prev => ({
                                                            ...prev!,
                                                            itemStatus: full,
                                                        }));
                                                    }}
                                                />
                                                <div className="separator-line" style={{ padding: 0 }} />
                                            </div>
                                        );
                                    })}

                                    <div className="flex gap-4 mt-4">
                                        <div className="flex-1">
                                            <button
                                                type="button"
                                                className="button button--light"
                                                onClick={() => {
                                                    setGearConditionSelectorModal(prev => ({
                                                        ...prev!,
                                                        __view: 'main',
                                                    }));
                                                }}
                                            >
                                                {t("Back")}
                                            </button>
                                        </div>
                                        <div className="flex-1">
                                            <button
                                                type="submit"
                                                className="button"
                                                onClick={() => {
                                                    const m = gearConditionSelectorModal;
                                                    if (!m) return;
                                                    if (!m.itemStatus?.includes(" - ")) return;
                                                    if (!m.gearConditionIdx) return;
                                                    setGearCondition(m.gearConditionIdx, m.itemStatus);
                                                    setGearConditionSelectorModal(null);
                                                }}
                                            >
                                                {t("Save")}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {gearNotTalabatConditionSelectorModal && (
                <div className={"bottom-modal"} tabIndex={-1} aria-modal="true" role="dialog">
                    <div className="bottom-modal__scroll-content">
                        <div className="bottom-modal__body" style={{ marginTop: "50px" }}>

                            <div className="stock-item__image">
                                <img
                                    src={gearNotTalabatConditionSelectorModal.imageUrl ?? ""}
                                    style={{ height: "60px", width: "auto" }}
                                    alt="Product"
                                />
                            </div>
                            <div className="flex justify-end mb-4">
                                <div
                                    className="bottom-modal__close"
                                    onClick={() => setGearNotTalabatConditionSelectorModal(null)}
                                >
                                    <CloseIcon />
                                </div>
                            </div>

                            {gearNotTalabatConditionSelectorModal.__view !== 'sub' && (
                                <>
                                    <div className="stock-item__title heading text-center mb-2">
                                        {gearNotTalabatConditionSelectorModal.gearName ?? ""}
                                    </div>
                                    <div className="text-light text-center mb-4">
                                        {t("Select the correct condition!")}
                                    </div>

                                    {Object.entries(gearNotTalabatConditionTypes).map(([mainKey, subOptions]) => (
                                        <div key={mainKey} className="mb-2">
                                            <RadioListItem
                                                label={t(mainKey)}
                                                selected={Boolean(gearNotTalabatConditionSelectorModal.itemStatus?.startsWith(mainKey))}
                                                onSelect={() => {
                                                    if (!subOptions) {
                                                        setGearNotTalabatConditionSelectorModal(prev => ({
                                                            ...prev!,
                                                            itemStatus: mainKey,
                                                        }));
                                                    } else {
                                                        setGearNotTalabatConditionSelectorModal(prev => ({
                                                            ...prev!,
                                                            __view: 'sub',
                                                            __selectedMain: mainKey,
                                                            itemStatus:
                                                                prev?.itemStatus?.startsWith(mainKey)
                                                                    ? prev.itemStatus
                                                                    : `${mainKey} - ${subOptions[0]}`,
                                                        }));
                                                    }
                                                }}
                                            />
                                            <div className="separator-line" style={{ padding: 0 }} />
                                        </div>
                                    ))}

                                    <div className="flex gap-4 mt-4">
                                        <div className="flex-1">
                                            <button
                                                type="button"
                                                className="button button--light"
                                                onClick={() => setGearNotTalabatConditionSelectorModal(null)}
                                            >
                                                {t("Back")}
                                            </button>
                                        </div>
                                        <div className="flex-1">
                                            <button
                                                type="submit"
                                                className="button"
                                                onClick={() => {
                                                    const m = gearNotTalabatConditionSelectorModal;
                                                    if (!m) return;
                                                    const selectedMain = m.itemStatus?.split(" - ")[0];
                                                    if (selectedMain && Array.isArray(gearNotTalabatConditionTypes[selectedMain])) {
                                                        setGearNotTalabatConditionSelectorModal(prev => ({
                                                            ...prev!,
                                                            __view: 'sub',
                                                            __selectedMain: selectedMain,
                                                        }));
                                                        return;
                                                    }
                                                    if (!m.gearConditionIdx || !m.itemStatus) return;
                                                    setGearNotTalabatCondition(m.gearConditionIdx, m.itemStatus);
                                                    setGearNotTalabatConditionSelectorModal(null);
                                                }}
                                            >
                                                {t("Save")}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}

                            {gearNotTalabatConditionSelectorModal.__view === 'sub' && (
                                <>
                                    <div className="stock-item__title heading text-center mb-2">
                                        {t(gearNotTalabatConditionSelectorModal.__selectedMain || "")}
                                    </div>
                                    <div className="text-light text-center mb-4">
                                        {t("Select a specific reason")}
                                    </div>

                                    {(gearNotTalabatConditionTypes[gearNotTalabatConditionSelectorModal.__selectedMain || ""] || []).map(sub => {
                                        const full = `${gearNotTalabatConditionSelectorModal.__selectedMain} - ${sub}`;
                                        return (
                                            <div key={sub} className="mb-2">
                                                <RadioListItem
                                                    label={t(sub)}
                                                    selected={gearNotTalabatConditionSelectorModal.itemStatus === full}
                                                    onSelect={() => {
                                                        setGearNotTalabatConditionSelectorModal(prev => ({
                                                            ...prev!,
                                                            itemStatus: full,
                                                        }));
                                                    }}
                                                />
                                                <div className="separator-line" style={{ padding: 0 }} />
                                            </div>
                                        );
                                    })}

                                    <div className="flex gap-4 mt-4">
                                        <div className="flex-1">
                                            <button
                                                type="button"
                                                className="button button--light"
                                                onClick={() => {
                                                    setGearNotTalabatConditionSelectorModal(prev => ({
                                                        ...prev!,
                                                        __view: 'main',
                                                    }));
                                                }}
                                            >
                                                {t("Back")}
                                            </button>
                                        </div>
                                        <div className="flex-1">
                                            <button
                                                type="submit"
                                                className="button"
                                                onClick={() => {
                                                    const m = gearNotTalabatConditionSelectorModal;
                                                    if (!m) return;
                                                    if (!m.itemStatus?.includes(" - ")) return;
                                                    if (!m.gearConditionIdx) return;
                                                    setGearNotTalabatCondition(m.gearConditionIdx, m.itemStatus);
                                                    setGearNotTalabatConditionSelectorModal(null);
                                                }}
                                            >
                                                {t("Save")}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>
                    </div>
                </div>
            )}
       



            {showAssignNewGearItem ? (
                <AssignNewGearItem
                    setAssignNewGearItem={setShowAssignNewGearItem}
                    fetchGears={fetchGears}
                    riderGears={gears}
                />
            ) : (
                <>

{/* TODO::TT ez volt az eredeti
                    <div className="button-container w-80">
                        {historicalGear === "1" && (
                            <button
                                type="button"
                                className="button"
                                onClick={() => setShowAssignNewGearItem(true)}
                            >
                                {t("Add historical gear data")}
                            </button>
                        )}
                        {historicalGear === "1" && Object.keys(gearsCondition).length === 0 && (
                            <button
                                type="button"
                                className={`button ${riderHasNoUniform ? "button--red-selected" : "button--red"}`}
                                onClick={handleNoUniformClick}
                            >
                                {riderHasNoUniform ? t("Uniform not provided") : t("Rider has no uniform")}
                            </button>
                        )}
                    </div>
*/}

                    {historicalGear === "1" && (
                        <div className="flex gap-4">
                            <div className="flex-1">
                                <button
                                    type="button"
                                    className="button"
                                    onClick={() => setShowAssignNewGearItem(true)}
                                >
                                    {t("Add historical gear data")}
                                </button>
                            </div>
                            <div className="flex-1">
                                {Object.keys(gearsCondition).length === 0 && (
                                    <button
                                        type="button"
                                        className={`button ${riderHasNoUniform ? "button--" : "button--"}`}
                                        onClick={handleNoUniformClick}
                                    >
                                        {riderHasNoUniform ? t("Uniform not provided") : t("Rider has no uniform")}
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                


                <div className="separator-line mb-2"></div>

 {/* TODO::TT ez volt az eredeti                   
                    <div className="flex flex-col justify-center items-center w-80">
                        {
                            historicalGear === "1" && Object.keys(gearsCondition).length > 0 ? (
                                <label className="checkbox mb-4">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => setAllGearsToGoodOrBad(e.target.checked)}
                                        required
                                        checked={riderApperanceIsGood === true}
                                    />
                                    <div className="checkbox__success-icon no-border see-through-background"></div>
                                    <div className="checkbox__text ">{t("Rider Appearance is Good")}</div>
                                </label>
                            ) : historicalGear === "0" ? (
                                <label className="checkbox mb-4">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => setAllGearsToGoodOrBad(e.target.checked)}
                                        required
                                        checked={riderApperanceIsGood === true}
                                    />
                                    <div className="checkbox__success-icon no-border see-through-background"></div>
                                    <div className="checkbox__text ">{t("Rider Appearance is Good")}</div>
                                </label>
                            ) : null
                        }
                    </div>
                    <div style={{height: '30px'}}>&nbsp;</div>
*/}


                {(
                    (historicalGear === "1" && Object.keys(gearsCondition).length > 0) || historicalGear === "0"
                ) && (    
                        <CheckBtn
                            label={t("Rider Appearance is Good")}
                            labelIcon={<HangerIcon/>}
                            selected={riderApperanceIsGood === true}
                            onChange={(checked) => setAllGearsToGoodOrBad(checked)}
                            className="mb-4 check-btn--purple-text check-btn--medium-text"
                            reversed={true}
                        />
                )}

                {/* TODO:TT ezt egyelőre beleégettem */}
                <div className="text-light mb-2">1/3</div>
                <div className="heading mb-2">{t("Gear Provided by Talabat")}</div>
                <div className="text-light mb-4">{t("Select the correct condition of each items!")}</div>

                            

{/* TODO::TT ez volt az eredeti}
                    <div className="card flex flex-col">
                        <table>
                            <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th className="text-xsmall text-center">{t("Good Condition")}</th>
                                <th className="text-xsmall text-center">{t("Not Wearing")}</th>
                                <th className="text-xsmall text-center">{t("Bad Condition")}</th>
                            </tr>
                            </thead>
                            {
                                Object.keys(gearsCondition).map((index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={{width: "36px"}}><img src={gearsCondition[index]["imageUrl"]}
                                                                             alt="gear"/>
                                            </td>
                                            <td>
                                                <div className="text-small">{gearsCondition[index]["gearBaseName"]}&nbsp;
                                                    <span
                                                        className="text-blue">{gearsCondition[index]["gearVariationName"]}</span>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <label className="checkbox mb-4">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => setGearCondition(parseInt(index), e.target.checked ? 'Good' : undefined)}
                                                        required
                                                        checked={gearsCondition[index]["itemStatus"] === 'Good'}
                                                    />
                                                    <div className="checkbox__success-icon no-border bg-gray"></div>
                                                </label>
                                            </td>
                                            <td className="text-center">
                                                <label className="checkbox mb-4">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => setGearCondition(parseInt(index), e.target.checked ? 'NotWearing' : undefined)}
                                                        required
                                                        checked={gearsCondition[index]["itemStatus"] === 'NotWearing'}
                                                    />
                                                    <div className="checkbox__success-icon no-border bg-gray"></div>
                                                </label>
                                            </td>
                                            <td className="text-center">
                                                <label className="checkbox mb-4">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => setGearCondition(parseInt(index), e.target.checked ? 'Bad' : undefined)}
                                                        required
                                                        checked={gearsCondition[index]["itemStatus"] === 'Bad'}
                                                    />
                                                    <div className="checkbox__success-icon no-border bg-gray"></div>
                                                </label>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </table>

                    </div>
*/}

                <div className="card flex flex-col gap-2">
                {
                    Object.keys(gearsCondition).map((index) => {
                        return (
                            <div className="flex gap-2">

                                <div className="item-image">
                                    <img src={gearsCondition[index]["imageUrl"]} alt="gear"/>
                                    {gearsCondition[index]["gearVariationName"] && <div className="item-image__variation-name">{gearsCondition[index]["gearVariationName"]}</div>}
                                </div>

                                <div 
                                    className="combined-btn"
                                    onClick={() => {
                                        setGearConditionSelectorModal({
                                            ...gearsCondition[index],
                                            gearConditionIdx: String(index),
                                            __view: 'main',
                                            __selectedMain: null,
                                        });
                                    }}
                                >
                                    <div>
                                        {/* TODO::TT ez a tulajdonság (unbranded) honnan jön?
                                        <div className="combined-btn__sublabel">Unbranded</div>*/}
                                        <div className="combined-btn__label">
                                            {gearsCondition[index]["itemStatus"] ? t(gearsCondition[index]["itemStatus"]) : t("Select Condition")}
                                        </div>
                                    </div>
                                    <AngleRightIcon/>
                                    
                                </div>
                            
                            </div>
                        )
                    })
                }
                </div>


                    <>
                        {
                            ((gears && gears.filter((product) => {
                                return !(product.exchangeDays && product.returnStatus !== ReturnStatus.MISSING);

                            }).length > 0) || (missingKitProducts && missingKitProducts.products.length > 0)) && <>
                               
                                {/* TODO:TT ezt egyelőre beleégettem */}
                                <div className="text-light mb-2 mt-8">2/3</div>
                                <div className="heading mb-4">{t("Gear Overdue or Not Received")}</div>
                                
                                <div className="card flex flex-col gap-2 mb-4">

{/* TODO::TT ez volt az eredeti
                                    <table  style={{ width: "100%" }}>
                                        <tbody>
                                        <>
                                            {
                                                gears && gears.map((product, index) => {
                                                    if (product.exchangeDays && product.returnStatus !== ReturnStatus.MISSING) {
                                                        return null;
                                                    }
                                                    return (
                                                        <tr key={index}>
                                                            <td style={{width: "36px"}}><img src={product.productImage} alt="gear"/>
                                                            </td>
                                                            <td>
                                                                <div className="text-small">{product.productName}</div>
                                                            </td>
                                                            <td  style={{
                                                                verticalAlign: "middle",
                                                                textAlign: "center",
                                                            }}>
                                                                <div
                                                                    className="text-small text-blue">{t('Overdue since:')} {product.exchangeAvailableAtConst}</div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }

                                            {missingKitProducts &&
                                                Object.entries(
                                                    missingKitProducts.products.reduce((groups, product) => {
                                                        const groupId = product.optionalGroupId ?? "ungrouped";
                                                        if (!groups[groupId]) groups[groupId] = [];
                                                        groups[groupId].push(product);
                                                        return groups;
                                                    }, {} as Record<string | number, KitProductModel[]>)
                                                ).map(([groupId, groupProducts], groupIndex) => {
                                                    if (groupId === "ungrouped") {
                                                        return groupProducts.map((product, index) => (
                                                            <tr key={`ungrouped-${index}`}>
                                                                <td style={{width: "36px"}}>
                                                                    <img src={product.image} alt="gear"/>
                                                                </td>
                                                                <td>
                                                                    <div className="text-small">{product.name}</div>
                                                                </td>
                                                                <td  style={{
                                                                    verticalAlign: "middle",
                                                                    textAlign: "center",
                                                                }}>
                                                                    <div
                                                                        className="text-small text-red">{t("Not received")}</div>
                                                                </td>
                                                            </tr>
                                                        ));
                                                    }

                                                    return (
                                                        <React.Fragment key={`grouped-${groupIndex}`}>
                                                            {groupProducts.map((product, index) => (
                                                                <tr
                                                                    key={`grouped-${groupId}-${index}`}
                                                                >
                                                                    {index === 0 && (
                                                                        <td rowSpan={groupProducts.length} style={{ verticalAlign: "middle" }}>
                                                                            {index === 0 && <img src={product.image} alt="gear" />}
                                                                        </td>
                                                                    )}
                                                                    <td>
                                                                        <div className={index === groupProducts.length - 1 ? "text-small last-row" : "text-small"}>
                                                                            {product.name}
                                                                            {index !== groupProducts.length - 1 && (
                                                                                <strong> or</strong>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    {index === 0 && (
                                                                        <td rowSpan={groupProducts.length}  style={{
                                                                            verticalAlign: "middle",
                                                                            textAlign: "center",
                                                                        }}>
                                                                            <div className="text-small text-red">{t("Not received")}</div>
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            ))}
                                                        </React.Fragment>
                                                    );
                                                })}
                                        </>
                                        </tbody>
                                    </table>
*/}
                                    
                                    {
                                        gears && gears.map((product, index) => {
                                            if (product.exchangeDays && product.returnStatus !== ReturnStatus.MISSING) {
                                                return null;
                                            }
                                            return (
                                                <div className="flex gap-2" key={index}>
                                                    <div className="item-image">
                                                        <img src={product.productImage} alt="gear"/>
                                                        {product.variationName && <div className="item-image__variation-name">{product.variationName}</div>}
                                                    </div>
                                                    <div className="combined-btn">
                                                        <div>
                                                            <div className="combined-btn__label">
                                                                {product.productName}
                                                            </div>
                                                            <div
                                                            className="combined-btn__sublabel">{t('Overdue since:')} {product.exchangeAvailableAtConst}</div>
                                                        </div>
                                                        {/*<AngleRightIcon/>*/}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }


                                    {missingKitProducts && Object.entries(
                                        missingKitProducts.products.reduce((groups, product) => {
                                            const groupId = product.optionalGroupId ?? "ungrouped";
                                            if (!groups[groupId]) groups[groupId] = [];
                                            groups[groupId].push(product);
                                            return groups;
                                        }, {} as Record<string | number, KitProductModel[]>)
                                    ).map(([groupId, groupProducts], groupIndex) => {
                                        if (groupId === "ungrouped") {
                                            return groupProducts.map((product, index) => (
                                                <div className="flex gap-2">
                                                    <div className="item-image">
                                                        <img src={product.image} alt="gear"/>
                                                    </div>
                                                    <div className="combined-btn">
                                                        <div>
                                                            <div className="combined-btn__label">
                                                                {product.name}
                                                            </div>
                                                            <div className="combined-btn__sublabel">
                                                                {t("Not received")}
                                                            </div>
                                                        </div>
                                                        {/*<AngleRightIcon/>*/} 
                                                    </div>
                                                </div>
                                            ));
                                        }

                                        // Csoportos termékeknél több név összefűzve
                                        const productNames = groupProducts
                                        .map((p, i) => (
                                            <React.Fragment key={i}>
                                                {p.name}
                                                {i < groupProducts.length - 1 && <> <strong>{t("or")}</strong> </>}
                                            </React.Fragment>
                                        ));

                                        return (
                                            <div className="flex gap-2" key={`grouped-${groupIndex}`}>
                                                <div className="item-image">
                                                    <img src={groupProducts[0].image} alt="gear" />
                                                </div>
                                                <div className="combined-btn">
                                                     <div>
                                                        <div className="combined-btn__label">{productNames}</div>
                                                        <div className="combined-btn__sublabel">{t("Not received")}</div>
                                                    </div>
                                                    {/*<AngleRightIcon/>*/} 
                                                </div>
                                            </div>
                                        );
                                    })}




                                </div>

                                <CheckBtn
                                    label={t("Communicated to the rider!")}
                                    labelIcon={<HornIcon/>}
                                    selected={gearsOverdueCommunicated === true}
                                    onChange={(checked) => setGearsOverdueCommunicated(checked)}
                                    className="mb-4 check-btn--purple-text check-btn--medium-text"
                                    reversed={true}
                                />
                            </>
                        }
                    </>



{/* TODO::TT ez volt az eredeti
                    <div className="card flex flex-col">
                        <table>
                            <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th className="text-xsmall text-center">{t("Good Condition")}</th>
                                <th className="text-xsmall text-center">{t("Not Wearing")}</th>
                                <th className="text-xsmall text-center">{t("Bad Condition")}</th>
                            </tr>
                            </thead>
                            {
                                Object.keys(gearsNotTalabatCondition).map((index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={{width: "36px"}}><img
                                                src={gearsNotTalabatCondition[index]["imageUrl"]}
                                                alt="gear"/></td>
                                            <td>
                                                <div
                                                    className="text-small">{gearsNotTalabatCondition[index]["gearName"]}</div>
                                            </td>
                                            <td className="text-center">
                                                <label className="checkbox mb-4">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => setGearNotTalabatCondition(parseInt(index), e.target.checked ? 'Good' : undefined)}
                                                        required
                                                        checked={gearsNotTalabatCondition[index]["itemStatus"] === 'Good'}
                                                    />
                                                    <div className="checkbox__success-icon no-border bg-gray"></div>
                                                </label>
                                            </td>
                                            <td className="text-center">
                                                <label className="checkbox mb-4">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => setGearNotTalabatCondition(parseInt(index), e.target.checked ? 'NotWearing' : undefined)}
                                                        required
                                                        checked={gearsNotTalabatCondition[index]["itemStatus"] === 'NotWearing'}
                                                    />
                                                    <div className="checkbox__success-icon no-border bg-gray"></div>
                                                </label>
                                            </td>
                                            <td className="text-center">
                                                <label className="checkbox mb-4">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => setGearNotTalabatCondition(parseInt(index), e.target.checked ? 'Bad' : undefined)}
                                                        required
                                                        checked={gearsNotTalabatCondition[index]["itemStatus"] === 'Bad'}
                                                    />
                                                    <div className="checkbox__success-icon no-border bg-gray"></div>
                                                </label>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </table>

                    </div>
                    <div style={{height: '30px'}}>&nbsp;</div>

              
*/}

                    <div className="text-light mb-2 mt-8">3/3</div>
                    <div className="heading mb-2">{t("Gear Not Provided by Talabat")}</div>
                    <div className="text-light mb-4">{t("Select the correct condition of each items!")}</div>

                    <div className="card flex flex-col gap-2 mb-4">
                        {
                            Object.keys(gearsNotTalabatCondition).map((index) => {
                                return (
                                    <div className="flex gap-2">

                                        <div className="item-image">
                                            <img src={gearsNotTalabatCondition[index]["imageUrl"]} alt="gear"/>
                                            {gearsNotTalabatCondition[index]["gearVariationName"] && <div className="item-image__variation-name">{gearsNotTalabatCondition[index]["gearVariationName"]}</div>}
                                        </div>

                                        <div 
                                            className="combined-btn"
                                            onClick={() => {
                                                setGearNotTalabatConditionSelectorModal({
                                                    ...gearsNotTalabatCondition[index],
                                                    gearConditionIdx: String(index),
                                                    __view: 'main',
                                                    __selectedMain: null,
                                                });
                                            }}
                                            >
                                            <div>
                                                {/* TODO::TT ez a tulajdonság (unbranded) honnan jön?
                                                <div className="combined-btn__sublabel">Unbranded</div>*/}
                                                <div className="combined-btn__label">
                                                    {gearsNotTalabatCondition[index]["itemStatus"] ? t(gearsNotTalabatCondition[index]["itemStatus"]) : t("Select Condition")}
                                                </div>
                                            </div>
                                            <AngleRightIcon/>
                                        </div>
                                    
                                    </div>     
                                )
                            })
                        }

                    </div>
                </>)}

            {showAssignNewGearItem ? null : (
                <>
                    {showError && (
                        <div className="text-red">
                            {!gearsOverdueCommunicated
                                ? t("Please confirm that you have communicated overdue or missing gear items to the rider.")
                                : t("Please select a condition for each gear item.")}
                        </div>
                    )}
                    {/*{showError && (
                        <Modal
                            message={t("Rider must have at least one gear, please use the add new historical gear function.")}
                            onClose={() => setShowError(false)}
                        />
                    )}*/}


                    

                    <div className="flex gap-4 mt-8">
            
                        <div className="flex-1">
                            <button type="submit" className="button button--light"  onClick={() => {
                                //setStep(1);
                                //setProgressStep(1);
                            }}>
                                {t("Back")}
                            </button>
                        </div>

                        <div className="flex-1">
                            <button
                                type="submit"
                                className="button"
                                onClick={() => handleNext()} 
                            >
                                {t("Next")}
                            </button>
                        </div>

                    </div>


                   
                </>
            )}
        </>
    );
};

export default GearCheckStep;